import { Component, ViewEncapsulation } from "@angular/core";
import { AppSettingsService } from "./services/appsettings.service";
import { varGlobal } from "./shared/varGlobal";

@Component({
  selector: "app-root",
  styleUrls: [
    //'../../node_modules/@progress/kendo-theme-default/dist/all.css', //theme kendo de base
    "../../src/app/@theme/kendo-theme/all.css", //theme kendo customisé spro
    "../../node_modules/angular2-toaster/toaster.css"
  ],
  template: `
    <!-- Necessaire pour afficher les notifications -->
    <toaster-container></toaster-container>
    <router-outlet></router-outlet>
  `,
  encapsulation: ViewEncapsulation.None
})
export class AppComponent {
  /**
   * Constructeur
   */
  constructor(
    public s_appsettings: AppSettingsService,
    public s_global: varGlobal
  ) {
    this.s_appsettings.proc_getSettings().subscribe(settings => {
      this.s_global.pathAPI = settings.pathAPI;
    });
  }
}



// WEBPACK FOOTER //
// C:/spro/Workspaces/VisualCode/Ecoltex2/src/app/app.component.ts